import script from "./ArgonSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./ArgonSnackbar.vue?vue&type=style&index=0&id=51bf49c1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51bf49c1"]])

export default __exports__